import React from 'react'
import { Carousel, User } from '.'

const CarouselQuotes = ({title = 'Quotes', data = []}) => {
  return (
    <div>
      <h3 className="lg:text-2xl mb-5 lg:mb-8 uppercase font-bold">
        { title }
      </h3>
      <Carousel slidesToScroll={1} slidesToShow={1} className="program-detail-carousel">
        {
          data.map((d, i) => (
            <div key={i} className="lg:pr-4">
              <p className="mb-5 text-sm text-gray-444">
                “{d.text ? d.text : 'Placeholder quote'}”
              </p>
              <User small name={d.name ? d.name : 'Username'}/>
            </div>
          ))
        }
      </Carousel>
    </div>
  )
}

export { CarouselQuotes }